module.exports = __webpack_public_path__ + "img/226-Veka Spectral 9016-Blanc Veka.jpg";